import {connect} from "react-redux";
import {withRouter} from 'react-router';

import * as AuthActions from "../store/actions/authActions";
import ForgotPassword from "../components/ForgotPassword";

const mapStateToProps = (state) => ({
    ...state.auth
});

const mapDispatchToProps = (dispatch) => ({
    requestPasswordReset: (email) => {
        dispatch(AuthActions.sendForgotPasswordEmail(email));
    },
    resetPassword: (token, password) => {
        dispatch(AuthActions.resetPassword(token, password));
    },
    resetPasswordStatus: () => {
       dispatch(AuthActions.resetPasswordResetStatus());
    },
    authClear: () => {
        dispatch(AuthActions.clearErrors());
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ForgotPassword);


// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordContainer.js